import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { currentSiteSelector, getSelectedDocumentState } from '../../store';
import { AppStore } from '../../store/states/app.state';
import { WkFabExpyConfigService } from './wk-fab-expy-config.service';

@Component({
  selector: 'wk-ai',
  templateUrl: './wk-ai.component.html',
  styleUrls: ['./wk-ai.component.scss'],
  standalone: false,
})
export class WkAIComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();
  private siteId: string;

  private selectedDocuments: Array<{
    id: string;
    title: string;
    url?: string;
  }> = [];

  constructor(
    private readonly fabConfigService: WkFabExpyConfigService,
    private readonly store: Store<AppStore>
  ) {}

  ngOnInit() {
    this.store
      .select(currentSiteSelector)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((siteId: string) => (this.siteId = siteId));
    this.store
      .select(getSelectedDocumentState)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((selectedDocuments) => {
        this.selectedDocuments = selectedDocuments
          .filter(({ url }) => url)
          .map(({ id, name, url }) => ({ id, title: name, url }));
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  openChat() {
    this.fabConfigService
      .getExpyChatSidebar(this.siteId, this.selectedDocuments)
      .render();
  }
}
